import React from "react";
import route from "../../../Route.json";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../app/store";
import { logoutApp } from "../../../features/authSlice";
import { toast } from "react-toastify";

const Headers = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const logout = () => {
    dispatch(logoutApp())
      .unwrap()
        .then((message) => {
          toast.success(message);
          navigate("/login");
        })
        .catch((error) => {
          toast.error(`Logout failed: ${error}`);
        });

  };
  return (
    <nav className="navbar navbar-expand-lg bg-white">
      <div className="container-fluid mx-5">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2  d-sm-block d-md-none d-md-block d-lg-none">
            {route.map((item, index) => (
              <li className="nav-item" key={index}>
                <Link className="nav-link" to={item.link}>
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-bell"></i>
                <sup>
                  <span className="badge bg-danger">
                    <small>12</small>
                  </span>
                </sup>
              </a>
              <ul className="dropdown-menu">
                <li className="nav-item" onClick={logout}>
                  <a className="nav-link" href="">
                    Logout
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Headers;
